"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _curry = _interopRequireDefault(require("transmute/curry"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _filter = _interopRequireDefault(require("transmute/filter"));

var _default = (0, _curry.default)(function (idStrings, campaigns) {
  return (0, _immutable.List)(idStrings.map(function (idString) {
    var ids = idString.split(';');
    return new _ReferenceRecord.default({
      id: idString,
      label: idString,
      referencedObject: (0, _immutable.fromJS)((0, _filter.default)(function (c) {
        return ids.indexOf(c.id) !== -1;
      }, campaigns))
    });
  }));
});

exports.default = _default;
module.exports = exports.default;